import { useEffect, useState } from "react";

import { useAppContext } from "@app/helpers/hooks";

export function useZipDetails(country_code: string) {
  const { geoData } = useAppContext();

  const [zip_type, setZipType] = useState<string | null>(
    geoData.getZip(country_code)
  );
  const [zip_regex, setZipRegex] = useState<RegExp | null>(
    geoData.getZipRegex(country_code)
  );
  const [zip_keyboard, setZipKeyboard] = useState<string | null>(
    geoData.getZipKeyboard(country_code)
  );

  useEffect(() => {
    setZipType(geoData.getZip(country_code));
    setZipRegex(geoData.getZipRegex(country_code));
    setZipKeyboard(geoData.getZipKeyboard(country_code));
  }, [country_code]);

  return {
    zip_type,
    zip_regex: zip_regex ? new RegExp(zip_regex) : zip_regex,
    zip_keyboard
  };
}
